import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { breakpoints, pxToRems, } from '@awaze/design-system.utils.react';
const spacings = {
    0: pxToRems(0),
    4: pxToRems(4),
    8: pxToRems(8),
    12: pxToRems(12),
    16: pxToRems(16),
    20: pxToRems(20),
    24: pxToRems(24),
    28: pxToRems(28),
    32: pxToRems(32),
    40: pxToRems(40),
    44: pxToRems(44),
    48: pxToRems(48),
    56: pxToRems(56),
    64: pxToRems(64),
    80: pxToRems(80),
    96: pxToRems(96),
    112: pxToRems(112),
    128: pxToRems(128),
    144: pxToRems(144),
    160: pxToRems(160),
    176: pxToRems(176),
    192: pxToRems(192),
};
export const StackStyled = styled.div `
  display: flex;
  height: ${({ fullHeight }) => (fullHeight ? '100%' : 'auto')};
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')};

  padding: 0;

  ${({ direction, align, justify, wrap, spacing, margin }) => {
    const directionIsArray = Array.isArray(direction);
    const alignIsArray = Array.isArray(align);
    const justifyIsArray = Array.isArray(justify);
    const wrapIsArray = Array.isArray(wrap);
    const spacingIsArray = Array.isArray(spacing);
    return css `
      gap: ${spacingIsArray ? spacings[spacing[0]] : spacings[spacing]};
      flex-direction: ${directionIsArray ? direction[0] : direction};
      flex-wrap: ${wrapIsArray ? wrap[0] : wrap};
      justify-content: ${justifyIsArray ? justify[0] : justify};
      align-items: ${alignIsArray ? align[0] : align};
      margin: ${Array.isArray(margin[0])
        ? margin[0].map((mar) => pxToRems(mar)).join(' ')
        : pxToRems(margin[0])};

      @media screen and (min-width: ${breakpoints[1]}px) {
        gap: ${spacingIsArray ? spacings[spacing[1]] : spacings[spacing]};
        flex-direction: ${directionIsArray ? direction[1] : direction};
        flex-wrap: ${wrapIsArray ? wrap[1] : wrap};
        justify-content: ${justifyIsArray ? justify[1] : justify};
        align-items: ${alignIsArray ? align[1] : align};
        margin: ${Array.isArray(margin[1])
        ? margin[1].map((mar) => pxToRems(mar)).join(' ')
        : pxToRems(margin[1])};
      }
      @media screen and (min-width: ${breakpoints[2]}px) {
        gap: ${spacingIsArray ? spacings[spacing[2]] : spacings[spacing]};
        flex-direction: ${directionIsArray ? direction[2] : direction};
        flex-wrap: ${wrapIsArray ? wrap[2] : wrap};
        justify-content: ${justifyIsArray ? justify[2] : justify};
        align-items: ${alignIsArray ? align[2] : align};
        margin: ${Array.isArray(margin[2])
        ? margin[2].map((mar) => pxToRems(mar)).join(' ')
        : pxToRems(margin[2])};
      }
    `;
}}

  & > *:not(style) {
    flex: ${({ equalChildren }) => (equalChildren ? '1' : '0 1 auto')};
  }
`;
/**
 * This is a layout component that makes it easy to stack elements together and apply a space between them.
 *
 * Several props allow you to control the direction, spacing and alignment of the contained elements.
 */
export const Stack = ({ align = 'normal', children, direction: directionProp = 'column', isHorizontal, justify = 'normal', spacing = 12, wrap = 'nowrap', fullHeight = false, equalChildren = false, className, margin = [0, 0, 0], ...rest }) => {
    const direction = isHorizontal ? 'row' : directionProp;
    return (_jsx(StackStyled, { align: align, direction: direction, justify: justify, spacing: spacing, wrap: wrap, fullHeight: fullHeight, equalChildren: equalChildren, className: className, margin: margin, ...rest, children: children }));
};
//# sourceMappingURL=stack.js.map